// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import Tdg_CompanyProfessionListPagingResultModel from '../../model/tdg-company-profession-list-paging-result-model';
import Tdg_CompanyProfessionListPagingResultDTO from '../dto/tdg-company-profession-list-paging-result-dto';
import dtoSchema from '../schemas/tdg-company-profession-list-paging-result-schema';
import Tdg_CompanyProfessionListModel from '../../model/tdg-company-profession-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class Tdg_CompanyProfessionListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<Tdg_CompanyProfessionListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => Tdg_CompanyProfessionListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: Tdg_CompanyProfessionListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<Tdg_CompanyProfessionListPagingResultDTO>): Tdg_CompanyProfessionListPagingResultModel;
  static toModel(dto: DeepPartial<Tdg_CompanyProfessionListPagingResultDTO> | undefined | null): Tdg_CompanyProfessionListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<Tdg_CompanyProfessionListPagingResultDTO> | undefined | null): Tdg_CompanyProfessionListPagingResultModel | undefined {
    return dto ? new Tdg_CompanyProfessionListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<Tdg_CompanyProfessionListPagingResultModel> | Tdg_CompanyProfessionListPagingResultModel): Tdg_CompanyProfessionListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as Tdg_CompanyProfessionListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for Tdg_CompanyProfessionListPagingResultModel, can not map to Tdg_CompanyProfessionListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
